export function addItemcode(itemcode, quantity) {
   fireGlobal('cart.add');

   const request = new Request.API_2_0('store/user/cart/product/' + itemcode, {
      method: 'POST',
   }).send({
      quantity: quantity,
      getMiniCartInfo: true,
   });

   notifyUser(request);
}

export function addProduct(productcode, optionid, quantity) {
   const itemcode = Utils.constructItemcode(productcode, optionid);
   addItemcode(itemcode, quantity);
}

export function addSkus(skus) {
   fireGlobal('cart.add');

   const request = new Request.API_2_0('store/user/cart/product', {
      method: 'POST',
   }).send({
      skus,
      pageSku: App.sku,
   });

   notifyUser(request);
}

function notifyUser(request) {
   // NOTE: consumers of this event trust `result.miniCart.html` to be
   // safe HTML.
   // LoadingIndicator should show error message from server, so do a no-op here.
   // However, we still want to rethrow JS exceptions from the success callback.
   request.then(result => fireGlobal('cart.addcomplete', result), () => {}).done();

   LoadingIndicator.withPromise(request, {
      pendingMessage: _js('Adding to cart'),
      successMessage: _js('Added'),
      failureMessage: _js('Could not add to cart'),
      useErrorResponseAsFailureMessage: true,
   });
}
